
  import { mapGetters } from 'vuex';

  export default {
    middleware: ['products/banking/prepay-cards/provider', 'breadcrumbs', 'meta-tags'],
    meta: { category: 'banking', metaTagOptions: { image: 'prepay-cards' } },
    computed: {
      ...mapGetters('providers', { provider: 'get' })
    }
  };
